var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.29476 12.8584H4.58951V15.5003L7.89179 12.8584H11.0633C11.7773 12.8584 12.358 12.2777 12.358 11.5636V6.3846C12.358 5.67054 11.7773 5.08984 11.0633 5.08984H3.29476C2.5807 5.08984 2 5.67054 2 6.3846V11.5636C2 12.2777 2.5807 12.8584 3.29476 12.8584Z",
    fill: "#A9A8B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6531 2.5H5.8846C5.17054 2.5 4.58984 3.0807 4.58984 3.79476H12.3584C13.0724 3.79476 13.6531 4.37545 13.6531 5.08951V10.2685C14.3672 10.2685 14.9479 9.68784 14.9479 8.97378V3.79476C14.9479 3.0807 14.3672 2.5 13.6531 2.5Z",
    fill: "#A9A8B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatGrey);
export default __webpack_public_path__ + "static/media/Chat_grey.82a3cb126d2a2fc95e2642a9894b04ee.svg";
export { ForwardRef as ReactComponent };